import { Action, action } from 'easy-peasy';

export interface OrderStoreModel {
  isOpen: boolean;
  close: Action<OrderStoreModel>;
  open: Action<OrderStoreModel>;
}

const orderStoreModel: OrderStoreModel = {
  isOpen: false,
  close: action((s) => {
    s.isOpen = false;
  }),
  open: action((s) => {
    s.isOpen = true;
  }),
};

export default orderStoreModel;
